module.exports = __webpack_public_path__ + "img/27.f47ca135.png";